import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFavorite } from '../api/favorite';

// 상세/수정 화면 헤더 별표용. 목록 응답과 달리 상세 API 에는 favorite 이 없어 단건 조회로 초기값을 받는다.
// 반환 [favorite, setFavorite] — setFavorite 는 FavoriteStar 의 onChanged 에 그대로 넘긴다.
export default function useFavorite(targetType, targetId, enabled = true) {
  const user = useSelector(state => state.user.user);
  const [favorite, setFavorite] = useState(false);
  const branchId = user?.branch?.branchId;

  useEffect(() => {
    if (!enabled || !targetId || !branchId) return;
    getFavorite(user.token, { branchId, targetType, targetId })
      .then(res => setFavorite(!!res?.favorite))
      .catch(() => setFavorite(false));
  }, [enabled, targetType, targetId, branchId, user?.token]);

  return [favorite, setFavorite];
}
